/* CRO features: sticky add to cart + Klaviyo back-in-stock (product page). No dependencies. */
(function () {
  'use strict';
  var KLAVIYO_BIS_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=';
  var KLAVIYO_REVISION = '2025-01-15';
  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 798px)') : null;

  function fmt(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var f = document.body.getAttribute('data-money-format') || '${{amount}}';
        return Shopify.formatMoney(cents, f);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function isShown(el) { return !!(el && !el.hidden && el.offsetParent !== null && el.getClientRects().length); }

  function init(container) {
    if (container.__cro) return;
    container.__cro = true;
    var vs = container.querySelector('[data-variant-selection]');
    var bis = container.querySelector('[data-cro-bis]');
    var sticky = container.querySelector('[data-cro-sticky]');
    var stickyBtn = sticky && sticky.querySelector('[data-cro-sticky-btn]');
    var mode = 'hide';
    /* main button label at load (e.g. "Add to cart" or "Pre-order"), before the theme rewrites it for sold-out variants */
    var addLabel = (function () {
      var b = container.querySelector('#AddToCart');
      var t = b && !b.disabled && b.querySelector('.text');
      return (t && t.textContent.trim()) || (sticky && sticky.getAttribute('data-label-add')) || 'Add to cart';
    })();
    var current = { variant: null, state: null };

    function mainBtn() { return container.querySelector('#AddToCart'); }
    function buttonsWrap() { return container.querySelector('.purchase-details__buttons'); }

    /* ---------- Back in stock ---------- */
    function setBis(variant, soldOut) {
      if (!bis) return;
      if (soldOut && variant) {
        bis.hidden = false;
        bis.setAttribute('data-variant', variant.id);
        var vEl = bis.querySelector('[data-cro-bis-variant]');
        if (vEl && variant.title !== '') vEl.textContent = variant.title && variant.title !== 'Default Title' ? '(' + variant.title + ')' : '';
        container.classList.add('cro-bis-active');
      } else {
        bis.hidden = true;
        container.classList.remove('cro-bis-active');
      }
      var msg = bis.querySelector('[data-cro-bis-msg]');
      if (msg && !soldOut) { msg.textContent = ''; msg.className = 'cro-bis__msg'; }
    }

    if (bis) {
      var form = bis.querySelector('[data-cro-bis-form]');
      var labels = {};
      try { labels = JSON.parse(bis.querySelector('[data-cro-bis-labels]').textContent); } catch (e) {}
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var btn = form.querySelector('button');
        var msg = bis.querySelector('[data-cro-bis-msg]');
        var email = (input.value || '').trim();
        var vid = bis.getAttribute('data-variant') || (current.variant && current.variant.id);
        var company = bis.getAttribute('data-company');
        msg.className = 'cro-bis__msg';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          msg.textContent = labels.invalid || 'Please enter a valid email address.';
          msg.classList.add('is-error');
          input.focus();
          return;
        }
        if (!vid || !company) return;
        btn.disabled = true;
        var payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } }
            }
          }
        };
        fetch(KLAVIYO_BIS_URL + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: KLAVIYO_REVISION },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (r.status === 202 || r.ok) {
            msg.textContent = labels.success || "You're on the list!";
            msg.classList.add('is-success');
            form.classList.add('is-done');
            document.dispatchEvent(new CustomEvent('cro:back-in-stock', { detail: { variantId: vid } }));
          } else {
            return r.text().then(function (t) { throw new Error(r.status + ' ' + t); });
          }
        }).catch(function (err) {
          if (window.console) console.warn('Back in stock signup failed', err);
          msg.textContent = labels.error || 'Sorry, something went wrong. Please try again.';
          msg.classList.add('is-error');
        }).then(function () { btn.disabled = false; });
      });
    }

    /* ---------- Sticky add to cart ---------- */
    function setSticky(variant, state, soldOut) {
      if (!sticky) return;
      var priceEl = sticky.querySelector('[data-cro-sticky-price]');
      var varEl = sticky.querySelector('[data-cro-sticky-variant]');
      if (variant) {
        if (priceEl && variant.price != null) priceEl.textContent = fmt(variant.price);
        if (varEl) varEl.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      } else if (varEl) {
        varEl.textContent = '';
      }
      var hasBis = sticky.getAttribute('data-bis') === 'true' && !!bis;
      var mb = mainBtn();
      if (soldOut) {
        mode = hasBis ? 'notify' : 'hide';
      } else if (!variant || state === 'not-selected' || (mb && mb.hasAttribute('data-options-unselected'))) {
        mode = state === 'unavailable' ? 'hide' : (mb ? 'choose' : 'hide');
      } else {
        mode = mb ? 'add' : 'hide';
      }
      var label = '';
      if (mode === 'add') {
        label = addLabel;
      } else if (mode === 'choose') {
        label = sticky.getAttribute('data-label-choose');
      } else if (mode === 'notify') {
        label = sticky.getAttribute('data-label-notify');
      }
      if (stickyBtn && label) stickyBtn.textContent = label;
      sticky.setAttribute('data-mode', mode);
      update();
    }

    function target() {
      if (container.classList.contains('cro-bis-active') && isShown(bis)) return bis;
      var w = buttonsWrap();
      if (isShown(w)) return w;
      if (isShown(bis)) return bis;
      return container;
    }

    var ticking = false;
    function update() {
      ticking = false;
      if (!sticky) return;
      var show = false;
      if (mode !== 'hide' && (!MOBILE || MOBILE.matches)) {
        var r = target().getBoundingClientRect();
        show = r.bottom < 0;
      }
      if (show !== sticky.classList.contains('is-visible')) {
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

    if (sticky) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      stickyBtn.addEventListener('click', function () {
        var mb = mainBtn();
        if (mode === 'add' && mb && !mb.disabled) {
          mb.click();
        } else if (mode === 'notify' && bis) {
          bis.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var inp = bis.querySelector('input[type="email"]');
          if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 350);
        } else {
          var opts = container.querySelector('options-selection, [data-options-selection], [data-variant-selection]') || container;
          opts.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    function apply(variant, state) {
      current.variant = variant || null;
      current.state = state;
      var soldOut = !!(variant && !variant.available);
      if (!variant && !mainBtn() && bis && bis.getAttribute('data-variant')) {
        /* whole product sold out and no option chosen yet: keep the server-rendered form */
        variant = { id: bis.getAttribute('data-variant'), title: '', available: false, price: null };
        soldOut = true;
      }
      setBis(variant, soldOut);
      setSticky(variant, state, soldOut);
    }

    if (vs) {
      vs.addEventListener('variant-change', function (e) {
        var d = e.detail || {};
        apply(d.variant || null, d.state);
      });
      var start = function () {
        if (typeof vs.getVariant !== 'function') return;
        Promise.all([vs.getVariant(), vs.getState()]).then(function (res) { apply(res[0] || null, res[1]); });
      };
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('variant-selection').then(start);
      } else {
        start();
      }
    } else {
      apply(null, 'unavailable');
    }
  }

  function boot() {
    var els = document.querySelectorAll('[data-cro-sticky], [data-cro-bis]');
    for (var i = 0; i < els.length; i++) {
      var c = els[i].closest('.product-form-container');
      if (c) init(c);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
